import {
    StyledDecisionSupport,
    StyledEdit,
} from '@/components/decisionSupport/DecisionSupport.styled';
import { DateRecommendationFragment } from '@/components/decisionSupport/queries/dateRecommendations.gql.types';
import { DialogType, useDialog } from '@/dialogs/DialogManager';
import { IconButton } from '@mui/material';
import { FC, useCallback } from 'react';

type DateDecisionSupportProps = {
    selectedDateRecommendation: DateRecommendationFragment | null;
    setSelectedDate(date: DateRecommendationFragment | null): void;
    recommendations: DateRecommendationFragment[];
    disabled?: boolean;
};

export const DateDecisionSupport: FC<DateDecisionSupportProps> = (props) => {
    const { selectedDateRecommendation, setSelectedDate, recommendations, disabled } = props;
    const { openDialog } = useDialog();

    const onClickEdit = useCallback(() => {
        openDialog(DialogType.DateDecisionSupport, {
            setSelectedDate,
            selectedDateRecommendation,
            recommendations,
        });
    }, [openDialog, recommendations, selectedDateRecommendation, setSelectedDate]);

    if (recommendations.length === 0) {
        return null;
    }

    return (
        <StyledDecisionSupport>
            <IconButton onClick={onClickEdit} disabled={disabled} aria-label='Edit date selection'>
                <StyledEdit />
            </IconButton>
        </StyledDecisionSupport>
    );
};
